import { render, staticRenderFns } from "./NamesComparison.vue?vue&type=template&id=a33fc8f2&scoped=true&"
import script from "./NamesComparison.vue?vue&type=script&lang=js&"
export * from "./NamesComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33fc8f2",
  null
  
)

export default component.exports